import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js";
import WebFont from "webfontloader";
import * as Sentry from "@sentry/react";

import * as serviceWorker from "./serviceWorker";

import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

WebFont.load({
  google: {
    families: ["Open Sans: 400,600", "san-serif"],
  },
});

Sentry.init({
  dsn:
    "https://9a33b811d8ba4654895515cef84c9e98@o178044.ingest.sentry.io/5505433",
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
